import PropTypes from 'prop-types';

// third-party
import SimpleBar from 'simplebar-react';
import { BrowserView, MobileView } from 'react-device-detect';

// ==============================|| SIMPLE SCROLL BAR  ||============================== //

export default function SimpleBarScroll({ children, sx, ...other }) {
  return (
    <>
      <BrowserView className="flex-grow h-full overflow-hidden">
        <SimpleBar
          timeout={500}
          clickOnTrack={false}
          className="max-h-full"
          style={{
            ...sx,
            // Custom scrollbar styles
            '--simplebar-scrollbar-bg': 'rgba(0, 0, 0, 0.48)',
            '--simplebar-scrollbar-hover-bg': 'rgba(0, 0, 0, 0.6)',
          }}
          {...other}
        >
          {children}
        </SimpleBar>
      </BrowserView>
      <MobileView>
        <div className="overflow-x-auto" style={sx} {...other}>
          {children}
        </div>
      </MobileView>
    </>
  );
}

SimpleBarScroll.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object
};
